<template>
    <div class="commerceClassroom-wrapper">
        <div class="content">
            <div class="main">
                <div class="logo">
                    <img src="@/assets/images/big-logo.png" alt="">
                </div>
                <h1>电商教室</h1>
            </div>
        </div>
        <div class="small-menu">
            <div class="main">
                <div class="list flex-start">
                    <div @click="gotosecond(item.title)" class="items flex-start" v-for="(item, index) in menu"
                        :key="index">
                        {{ item.title }}
                        <img class="icon" src="@/assets/images/up-icon.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="new-list">
                <div class="left">
                    <div class="home-tag flex-start">
                        <div class="items">电商教室</div>
                        <img class="icon" src="@/assets/images/tag-right.png" alt="">
                        <div class="items">{{ news.title }}</div>

                    </div>
                    <div class="big-img">
                        <img :src="news.thumb" alt="">
                    </div>
                    <div class="big-title">{{ news.title }}</div>
                    <div class="info-item flex-bt">
                        <div class="tag-box-big flex-bt">
                            <template v-for="(item, index) in news.tag">
                                <div class="items" :key="index">{{
                                    item }}
                                </div>
                            </template>

                        </div>
                        <span>{{ news.addtime }}</span>
                    </div>
                    <div v-html="news.content" class="big-content">

                    </div>

                </div>
                <div class="right">
                    <div class="online-store">
                        <div class="title">网店实战工作坊</div>
                        <div class="img">
                             <a target="_blank" :href="blogset.gzfurl" > <img :src="blogset.gzfjpg" alt=""></a>
                        </div>
                        <div class="button-box flex-bt">
                            <div @click="changerightlist('hot')" :class="rightactive == 'hot' ? 'items' : 'items active'">
                                热门文章
                            </div>
                            <div @click="changerightlist('tui')" :class="rightactive == 'tui' ? 'items' : 'items active'">
                                编辑推荐
                            </div>
                        </div>
                        <div class="small-list">
                            <div class="items flex-start" v-for="(item, index) in rightList" :key="index">
                                <p class="num">{{ index + 1 }}</p>
                                <router-link :to="'/newsDetail?id=' + item.id"> <span>{{ item.title }}</span> </router-link>
                            </div>
                        </div>
                    </div>
                    <!-- tag -->
                    <div class="tag-list">
                        <div class="title">Tag Cloud</div>
                        <div class="tag-box">
                            <template v-for="(item, index) in result.tag">
                                <div    :key="index" v-if="item" class="items">	<router-link   :to="'/commerceClassroomList?tag=' + item"> 
								<p style="color: black;">{{ item }}</p>
							</router-link>
                                </div>
                            </template>
                        </div>
                    </div>


                    <!-- about -->
                    <div class="about">
                        <div class="title">{{ blogset.zhuiTitle }}</div>
                        <div class="content-box">{{ blogset.guanyu }}</div>
                        <router-link to="/consultation">
                            <div class="button-box">立即预约</div>
                        </router-link>

                    </div>

                    <!--  -->
                    <div class="track">
                        <div class="title">追踪LOOPSHOP</div>
                        <div class="list">
                           <iframe
                               src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Floopshop.hk&tabs=timeline&width=396&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                               width="300" height="70" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
                               allowfullscreen="true"
                               allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AdBox></AdBox>
        <Start></Start>
    </div>
</template>
<script>
import Start from '@/components/Start.vue'
import AdBox from '@/components/AdBox.vue'
export default {
    components: { Start, AdBox },
    data() {
        return {
			head: {
			  title: 'My Page Title',
			  meta: [
			    { name: 'description', content: 'This is the description of my page' },
			    { name: 'keywords', content: 'keyword1, keyword2, keyword3' },
			  ]
			},
            blogset: [],
            id: 8,
            rightactive: 'hot',
            result: {},
            rightList: [],
            news: [],
            menu: [

            ],
            smallList: [
                { title: 'iOS 14 私隐政策 2021 更新：网店收入将受波及？即睇电商广告应对策略！' },
                { title: 'iOS 14 私隐政策 2021 更新：网店收入将受波及？即睇电商广告应对策略！' },
                { title: 'iOS 14 私隐政策 2021 更新：网店收入将受波及？即睇电商广告应对策略！' },
                { title: 'iOS 14 私隐政策 2021 更新：网店收入将受波及？即睇电商广告应对策略！' },
                { title: 'iOS 14 私隐政策 2021 更新：网店收入将受波及？即睇电商广告应对策略！' },
            ],
            tag: [

            ]
        }
    },
    mounted() {
		//this.$meta().refresh()
		
        // this.getCaseList()
    },

    created(option) {



        if (this.$route.query.id) {
            this.id = this.$route.query.id
        }
        this.getMenuList()
        this.getList()
        this.getBlogSet()
    },
    watch: {
        '$route.query.id': {
            handler: function (val) {
                if (val && val != this.id) {
                    this.id = this.$route.query.id
                    this.getList()
                }
            },
            immediate: true
        }
    },
    methods: {
        async getBlogSet() {

            let fdata = { do: 'getset', goto: 'blogset', orderby: 'orderid asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.blogset = res

        },

        formatDateTime(timestamp) {
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} `;
			//${hours}:${minutes}:${seconds}
        },


        gotosecond(id) {
            this.$router.push('/commerceClassroomList?class_type=' + id);
        },

        changerightlist(item) {
            this.rightactive = item
            this.rightList = this.result[item]
        },
        async getList() {
            this.showMoreBtn = false
            let fdata = { do: 'newsdetail', id: this.id }
            let res = await this.$api.funk(fdata)
            res.news.tag = res.news.tag.split(',')
            res.news.addtime = this.formatDateTime(res.news.addtime)
            this.result = res
            this.news = res.news
			document.title = this.news.title;
            this.rightList = res.hot
        },
        async getMenuList() {
            this.showMoreBtn = false
            let fdata = { do: 'json', sjk: 'classtype', orderby: 'orderid asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.menu = res

        },

    }
}
</script>
<style lang="scss" scoped>
.commerceClassroom-wrapper {
    .home-tag {
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 400;
        font-size: 0.16rem;
        line-height: 0.16rem;
        color: #000000;

        .icon {
            margin: 0 0.12rem;
            width: 0.08rem;
            height: 0.14rem;
            display: block;
        }
    }

    .big-img {
        width: 100%;
        margin-top: 0.38rem;

        img {
            width: 100%;
            display: block;
        }
    }

    .info-item {
        margin: 0.16rem 0;

        span {
            font-size: 0.2rem;
        }
    }



    .big-title {
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 600;
        font-size: 0.32rem;
        line-height: 0.46rem;
        color: #000000;
        margin-top: 0.24rem;
    }

    .tag-box-big {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .items {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 400;
            font-size: 0.16rem;
            line-height: 0.22rem;
            padding: 0.04rem 0.08rem;
            color: #E02E43;
            margin: 0 0.06rem 0.06rem 0;
            border: 1px solid #E02E43;
            border-radius: 4px;
            cursor: pointer;

            &:nth-child(7n) {
                margin-right: 0px;
            }
        }
    }

    .big-content {
        margin-top: 0.26rem;
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 400;
        font-size: 0.12rem;
        line-height: 0.18rem;
        color: #000000;
    }

    .new-list {
        display: flex;
        justify-content: space-between;
        margin-top: 0.76rem;
        width: 100%;

        .left {
            width: 8.4rem;
        }

        .right {
            width: 4rem;
        }

        .track {
            margin-top: 0.5rem;

            .title {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
            }

            .list {
                width: 100%;
                background: #EBEBEB;
                margin-top: 0.16rem;

                .items {
                    width: 100%;
                    background: #D9D9D9;
                    padding: 0.16rem;

                    .logo {
                        width: 0.88rem;
                        height: 0.88rem;
                        background: #8B8B8B;
                        margin-right: 0.16rem;

                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }

                    .text {
                        height: 0.88rem;

                        .name {
                            font-family: 'Microsoft YaHei';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 0.24rem;
                            line-height: 0.32rem;
                            color: #000000;
                        }

                        .text2 {
                            font-family: 'Microsoft YaHei';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 0.24rem;
                            line-height: 0.32rem;
                            color: #000000;
                            margin-top: 0.08rem;
                        }
                    }
                }
            }
        }
        .about {
            margin-top: 0.5rem;

            .title {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
            }

            .content-box {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.12rem;
                line-height: 0.18rem;
                color: #000000;
                margin-top: 0.16rem;
            }

            .button-box {
                width: 100%;
                height: 0.64rem;
                background: #E02E43;
                border-radius: 0.08rem;
                text-align: center;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.64rem;
                color: #FFFFFF;
                margin-top: 0.16rem;
                cursor: pointer;
            }
        }

        .tag-list {
            margin-top: 0.4rem;

            .title {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
                margin-bottom: 0.16rem;
            }

            .tag-box {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .items {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.16rem;
                    line-height: 0.22rem;
                    padding: 0.04rem 0.08rem;
                    color: #E02E43;
                    margin: 0 0.06rem 0.06rem 0;
                    border: 1px solid #E02E43;
                    border-radius: 4px;
                    cursor: pointer;

                    &:nth-child(7n) {
                        margin-right: 0px;
                    }
                }
            }
        }

        .online-store {
            .title {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #000000;
                margin-bottom: 0.08rem;
            }

            .img {
                width: 100%;
                height: 3rem;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .small-list {
                .items {
                    width: 100%;
                    height: 0.8rem;
                    border-bottom: 1px solid #CCCCCC;
                    cursor: pointer;

                    .num {
                        width: 0.4rem;
                        height: 0.4rem;
                        background: #E02E43;
                        text-align: center;
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 0.24rem;
                        line-height: 0.4rem;
                        text-align: center;
                        color: #FFFFFF;
                        margin-right: 0.16rem;
                    }

                    span {
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.16rem;
                        line-height: 0.22rem;
                        color: #000000;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        flex: 1;
                    }
                }
            }

            .button-box {
                margin-top: 0.4rem;

                .items {
                    width: 1.9rem;
                    height: 0.8rem;
                    background: #E02E43;
                    cursor: pointer;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.8rem;
                    color: #fff;
                    text-align: center;

                    &.active {
                        background: #FAFAFA;
                        /* Red/100 */
                        border: 2px solid #E02E43;
                        color: #E02E43;
                    }
                }
            }
        }
    }

    .small-menu {
        width: 100%;
        height: 0.64rem;
        background: #E02E43;

        .list {
            height: 0.64rem;

            .items {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.2rem;
                line-height: 0.2rem;
                color: #FFFFFF;
                margin-right: 0.4rem;
                height: 100%;
                cursor: pointer;

                .icon {
                    width: 0.24rem;
                    height: 0.24rem;
                    margin-left: 0.08rem;
                }
            }
        }
    }

    .content {
        width: 100%;
        height: 3.4rem;
        background: url('~@/assets/images/commerceClassroom-bgs.png')no-repeat center center /100% 100%;
        padding-top: 0.86rem;

        .logo {
            height: 0.8rem;
            width: 1.74rem;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }

        h1 {
            width: 100%;
            text-align: center;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.56rem;
            line-height: 0.78rem;
            letter-spacing: 0.05em;
            color: #000000;
            margin-top: 0.12rem;
        }
    }
}

@media (max-width: 750px) {
    .commerceClassroom-wrapper .small-menu .list .items {
        display: none;
    }

    .commerceClassroom-wrapper .new-list .right {
        display: none;
    }

    .commerceClassroom-wrapper .home-tag {
        display: none;
    }


}
</style>